import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'AFIA',
    localizedName: {
        ar: 'عافية',
        en: 'AFIA'
    },
    description: 'AFIA is your daily health companion: Egyptian recipes, calorie tracking, meal planning, workouts and grandmothers’ wisdom in one place.',
    localizedDescription: {
        ar: 'عافية رفيقك الصحي اليومي: وصفات مصرية صحية، متابعة السعرات، مخطط وجبات أسبوعي، تمارين، وحكمة الجدّات في مكان واحد.',
        en: 'AFIA is your daily health companion: Egyptian recipes, calorie tracking, meal planning, workouts and grandmothers’ wisdom in one place.'
    },
    placeholder: '',
    url: getOrigin(),
    ogImage: '/images/recipes/grilled-tilapia.jpg'
}
